// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const srb = {
  app: `app`,
  user: `korisnik`,
  list: `niz`,
  edit: `izmeni`,
  shop: `kupi`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  find: 'Pronađi',
  cards: `kartice`,
  posts: `postovi`,
  create: `napravi`,
  kanban: `kanban`,
  submit: 'Pošalji',
  close: 'Odustani',
  general: `Opste`,
  banking: `bankarstvo`,
  booking: `knjigovodstvo`,
  profile: `profil`,
  account: `konto`,
  product: `proizvod`,
  invoice: `faktura`,
  details: `detalji`,
  checkout: `checkout`,
  calendar: `kalendar`,
  optional: 'Opciono',
  analytics: `analitika`,
  ecommerce: `e-commerce`,
  management: `upravljanje`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `opis`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  create_pricelist: `napravi cenovnik`,
  payment: `Plaćanje`,
  payment_order: `Platni promet`,
  till_managment: `Upravljanje blagajnom`,
  till_states: `Stanje blagajne`,
  limit_passed: `Limit prekoračen`,
  subTill_limit_statistics: `Statistika limita podblagajne`,
  sub_tills_not_found: `Podblagajne nisu pronađene`,
  home: `Početna`,
  Cart: `Korpa`,
  subtill_transactions: `Transakcije podblagajne`,
  history_of_changes: `Istorija promena`,
  subtill_limits: `Limit podblagajne`,
  till_register_diary: `Dnevnik blagajne`,
  sum_of_till_register_diary_for_location: `Suma dnevnika blagajne za lokaciju`,
  till_not_found: `Blagajna nije pronađena`,
  close_till: `Zatvori blagajnu`,
  open_till: `Otvori blagajnu`,
  reference: `Referenca`,
  date_time: `Datum i vreme`,
  input: `Ulaz`,
  output: `Izlaz`,
  amount: `Iznos`,
  currency: `Valuta`,
  code: `Šifra`,
  balance: `Stanje`,
  name: `Ime`,
  type: `Tip`,
  document_number: `Broj dokumenta`,
  operater: `Operater`,
  date_to: `Do datuma`,
  date_from: `Od datuma`,
  Location: `Lokacija`,
  location: `Lokacija`,
  Per_page: `Po stranici`,
  Home: `Početna`,
  Enter: `Unesi`,
  Confirm: `Potvrdi`,
  Cancel: `Otkaži`,
  Search: `Pretraži`,
  Reset: `Resetuj`,
  Save: `Sačuvaj`,
  Edit: `Izmeni`,
  Delete: `Obriši`,
  Back: `Nazad`,
  Next: `Sledeći`,
  Previous: `Prethodni`,
  Close: `Zatvori`,
  comment: 'Komentar',
  Open: `Otvori`,
  Print: `Štampaj`,
  Export: `Izvezi`,
  Import: `Uvezi`,
  Import_data: `Uvezi podatke`,
  Export_data: `Izvezi podatke`,
  Input_from_bank: `Ulaz iz bankomata`,
  Output_from_bank: `Izlaz u bankomat`,
  valid_from_date: `Validan od`,

  location_name: `ime lokacije`,
  amount_from: `iznos od`,
  amount_to: `iznos do`,

  successful_copy: 'Uspešno kopiranje',

  /* ------------------ */
  /*  Till mannagement  */
  /* ------------------ */
  time: 'Vreme',
  status: 'Status',
  refund: 'Storno',
  subtills: 'Podblagajne',
  to_refund: 'Storniraj',
  set_limit: 'Postavi limit',
  opened_till: 'Otvorena blagajna',
  closed_till: 'Zatvorena tilblagajna',
  service_type: 'Tip usluge',
  general_input: 'Opšti ulaz',
  refund_reason: 'Razlog za storniranje',
  general_output: 'Opšti izlaz',
  output_number: 'Broj izlaza',
  internal_input: 'Interni ulaz',
  internal_output: 'Interni izlaz',
  input_from_bank_account: 'Ulaz sa računa',
  output_to_bank_account: 'Izlaz na račun',
  till_management: 'Upravljanje blagajnom',
  is_refunded: 'Stornirane',
  regular_currency: 'Regularan novac',
  from_last_opening: 'Od zadnjeg otvaranja',
  till_transactions: 'Transakcije blagajne',
  obsolete_damaged_currency: 'Ošt/vanopt. novac',
  transaction_type: 'Tip transakcije',
  sub_till_limits_state: 'Stanje limita podblagajni',
  make_till_transaction: 'Izvršite blagajničku transakciju',
  make_till_input_transaction: 'Izvršite ulaz u blagajnu',
  make_till_output_transaction: 'Izvršite izlaz u blagajnu',
  internal_output_for_input: 'Interni izlaz za koji se kreira ulaz',
  internal_input_from_exchange_till: 'Interni ulaz iz menjačke blagajne',
  transaction_created_successfully: 'Blagajnička transakcija je uspešno izvršena',
  till_opened_successfully: 'Blagajna je uspešno otvorena',
  till_closed_successfully: 'Blagajna je uspešno zatvorena',
  till_transaction_refunded_successfully: 'Blagajnička transakcija uspešno stornirana',
  Success_set_base_debt_limit_agent: 'Uspešno ažuriran bazni limit agenta',
  Success_updated_location_debt_limit_for_currency: 'Uspešno ažuriran bazni limit za lokaciju',
  banknote_balance: 'Balans papirnog',
  coin_balance: 'Balans kovanica',

  // WU
  mtcn: 'MTCN',
  sender: 'Pošiljalac',
  receiver: 'Primalac',
  transactions: 'Transakcije',
  reference_number: 'Referentni broj',
  transactions_table: 'Tabela transakcija',
  transaction_overview: 'PRegled transakcije',
  search_and_overview: 'Pretraga i pregled',
  WU_root: 'Western Union',
  WU_search_and_overview: 'Pretraga i pregled',
  WU_transaction_overview: 'Pregled transakcije',
};

export default srb;
